import React from 'react'

import { reverse } from 'named-urls'
import { Link } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'
import qs from 'qs'
import moment from 'moment'

import { Box, Button, Divider, Paper, Typography } from '@material-ui/core'

import { routes } from 'routes'
import { DotStatus } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import * as service from 'service'
import useFetch from 'hooks/useFetch'
import helpers from 'helpers'

const LatestContracts = ({ clientId }) => {
  const { response, isLoading } = useFetch(service.recurrence.contracts.get, {
    contract: {
      customerId: clientId,
    },
    perPage: 5,
  })

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="h4">Últimas assinaturas</Typography>
        <Button
          color="primary"
          variant="outlined"
          component={Link}
          to={{
            pathname: '/contracts',
            search: qs.stringify({ customerId: clientId }),
          }}
        >
          Detalhar
        </Button>
      </Box>
      <Divider />
      <PerfectScrollbar>
        <Table
          emptyMessage="Não há assinaturas desse cliente"
          isLoading={isLoading}
          noWrap
        >
          <TableHead>
            <TableRow>
              <TableCell>Assinatura</TableCell>
              <TableCell>Código</TableCell>
              <TableCell>Data de geração</TableCell>
              <TableCell align="center">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {response &&
              response.data.contracts.map(contract => (
                <TableRow
                  to={reverse(routes.contracts.show, {
                    contractId: contract.id,
                  })}
                  key={contract.id}
                  hover
                >
                  <TableCell>{contract.id}</TableCell>
                  <TableCell>{contract.code}</TableCell>
                  <TableCell>
                    {moment(contract.createdAt).format('DD/MM/YYYY')}
                  </TableCell>
                  <TableCell align="center">
                    <DotStatus
                      statusName={helpers.contracts.status(contract.status)}
                      size="small"
                      statusTag={contract.status}
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
    </Paper>
  )
}

export default LatestContracts
